import React, { useState, useMemo } from "react";
import { Button, Modal } from "react-bootstrap";

function ComponentSearchModal({ products, componentsOrdered }) {
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState("");

  const searchIndex = useMemo(() => {
    if (!products?.[0]?.subtypes) return [];
    return products[0].subtypes.flatMap((subtype) => {
      if (componentsOrdered && !componentsOrdered.includes(subtype.name))
        return [];
      const description =
        subtype.coverage_description !== null
          ? subtype.coverage_description
          : subtype.description;
      if (!description) return [];
      return description
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0)
        .map((line) => ({ item: line, component: subtype.name }));
    });
  }, [products, componentsOrdered]);

  const results = useMemo(() => {
    if (!query.trim() || query.trim().length < 2) return [];
    const q = query.toLowerCase();
    return searchIndex.filter(
      (entry) =>
        entry.item.toLowerCase().includes(q) ||
        entry.component.toLowerCase().includes(q),
    );
  }, [query, searchIndex]);

  const handleClose = () => {
    setShow(false);
    setQuery("");
  };

  return (
    <>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setShow(true)}
        className="float-end"
      >
        Is It Covered?
      </Button>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <strong>Search Coverage</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Type a part or component name..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
          />
          {results.length > 0 ? (
            <ul className="list-group">
              {results.map((result, index) => (
                <li
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <span
                    className={
                      result.item.includes(":") ? "fw-bold" : undefined
                    }
                  >
                    {result.item.replace(/:$/, "")}
                  </span>
                  <span className="text-muted small ms-3 text-end">
                    {result.component}
                  </span>
                </li>
              ))}
            </ul>
          ) : query.trim().length >= 2 ? (
            <p className="text-muted">No matching components found.</p>
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ComponentSearchModal;
